import { render, staticRenderFns } from "./Qyxxbg.vue?vue&type=template&id=59c62e20&scoped=true&"
import script from "./Qyxxbg.vue?vue&type=script&lang=js&"
export * from "./Qyxxbg.vue?vue&type=script&lang=js&"
import style0 from "./Qyxxbg.vue?vue&type=style&index=0&id=59c62e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c62e20",
  null
  
)

export default component.exports